import * as React from "react";
const SvgChevronSelector = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.83301 13.0026L9.99967 17.1693L14.1663 13.0026M5.83301 8.0026L9.99967 3.83594L14.1663 8.0026" }));
export default SvgChevronSelector;
